import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import ShareModal from 'containers/project-results/share-modal'
import {
  moreCompletionsNeededThanAvailableSlots,
} from 'shared/helpers/functional'
import { pathEq, either, path } from 'ramda'
import Sidebar from 'containers/sidebar'
import SubRouteContainer from 'containers/project/subroute-container'
import CustomCrowdThankYouModal from 'containers/project/custom-crowd-thank-you-modal'
import { isPMOrAdmin, isQSAdmin } from 'shared/helpers/user'
import { localizedTranslate } from 'assets/localization'
import { getEmailTemplate } from 'store/editSession/editSessionActions'
import {
  editConferenceLinkDetails,
  toggleEditConferenceLinkModal,
  toggleTranslationsModal,
  setMeetingInfromation,
  addConferenceLinkMeetingInfoTranslations,
  addTranslations,
  clearTranslations,
  fetchAllInformationForProject,
  deleteTranslation,
  toggleInconsistentMeetingInformationModal,
  toggleTranslationsErrorModal,
  toggleTopicTransltionsErrorModal,
  deleteTranslationDirectly,
  addTopicNameTranslations,
  deleteTopicTransltion
} from 'store/project/projectActions'



class Project extends React.Component {
  constructor (props) {
    super(props)
    this.isPMOrAdmin = isPMOrAdmin()
    this.isQSAdmin = isQSAdmin()
    this.state = {
      modalOpen: false,
      fetched: false,
      warnings: {
        moreCompletionsNeededThanAvailableSlots: false,
      },
      linksArray: [{
        display:'Projects',
        icon: 'im-ss-inboxes',
        path: '/projects',
      }, {
        display: 'Interviews',
        icon: 'im-ic-interview',
        path: '/interviews',
      }, {
        display: isPMOrAdmin? 'All Moderator Calendar' :'My Schedule',
        icon: isPMOrAdmin? 'im-calendar-all-moderator' : 'im-calendar',
        path: '/moderator/schedule',
        className: isPMOrAdmin? 'all-moderator-schedule' : '',
      }, 
      {
        display: 'Moderator Management',
        icon: 'im-user2',
        path: '/moderatorManagement/schedule',
        className: 'all-moderator-schedule',
      },
      {
        display: 'Profile',
        icon: 'im-ss-user',
        path: '/profile',
      }]
    }
  }

  componentDidMount () {
    const pathnameEq = pathEq(['location', 'pathname'])
    const pathWithoutProjectId = either(pathnameEq('/projects'), pathnameEq('/projects/creation'))
    if (pathWithoutProjectId(this.props)) {
      this.props.history.replace('/projects')
    }
    if (this.isQSAdmin) {
      let linksArr = this.state.linksArray.slice()
      linksArr.splice(4, 0, 
        {
          display: 'User Management',
          path: '/userManagement',
          className: 'user-management',
        })
      this.setState({ linksArray: linksArr })
    }
  }

  closeModal = () => {
    this.setState({ modalOpen: false, modalState: {} })
  }

  openModal = (modalState) => {
    this.setState({ modalOpen: true, modalState })
  }

  updateState = (stateUpdate) => {
    this.setState(stateUpdate)
  }

  subRouteMapper = (route, index) => (
    <Route
      key={index}
      exact
      path={route.path}
      render={(props) => {
        const timeSlotId = path(['match', 'params', 'timeSlotId'], props)
        const timeSlotInfo = this.state[timeSlotId] || {}
        const projectId = path(['match', 'params', 'projectId'], props)
        const projectInfo = this.state[`project:${projectId}`] || {}
        const shareHash = timeSlotInfo.shareHash || projectInfo.shareHash
        return (
          <SubRouteContainer
            {...props}
            timeSlotInfo={timeSlotInfo}
            shareHash={shareHash}
            warnings={{
              moreCompletionsNeededThanAvailableSlots:
                this.props.currentProject.availabilityCount > 0 &&
                moreCompletionsNeededThanAvailableSlots(
                  this.props.currentProject.surveys,
                  this.props.currentProject.availabilityCount
                ),
            }}
            survey={this.props.survey}
            component={route.component}
            openModal={this.openModal}
            launch={this.launch}
            currentProject={this.props.currentProject}
            surveyErrors={this.props.surveyErrors}
            displayAllErrors={this.props.displayAllErrors}
            questionErrors={this.props.questionErrors}
            fetchAllInformationForProject={this.props.fetchAllInformationForProject}
            t={this.props.t}
            showSnackbarMessageError={this.props.showSnackbarMessageError}
            hideSnackbarMessage={this.props.hideSnackbarMessage}
            toggleEditConferenceLinkModal={this.props.toggleEditConferenceLinkModal}
            editConferenceLinkDetails={this.props.editConferenceLinkDetails}
            toggleTranslationsModal={this.props.toggleTranslationsModal}
            setMeetingInfromation={this.props.setMeetingInfromation}
            addConferenceLinkMeetingInfoTranslations={this.props.addConferenceLinkMeetingInfoTranslations}
            addTranslations= {this.props.addTranslations}
            clearTranslations= {this.props.clearTranslations}
            deleteTranslation={this.props.deleteTranslation}
            toggleInconsistentMeetingInformationModal={this.props.toggleInconsistentMeetingInformationModal}
            toggleTranslationsErrorModal={this.props.toggleTranslationsErrorModal}
            toggleTopicTransltionsErrorModal={this.props.toggleTopicTransltionsErrorModal}
            deleteTranslationDirectly={this.props.deleteTranslationDirectly}
            getEmailTemplate = {this.props.getEmailTemplate}
            previewConferenceLinkModal = {this.props.previewConferenceLinkModal}
            exampleEmail = {this.props.exampleEmail} 
            closePreviewLinkModal = {this.props.closePreviewLinkModal}
            addTopicNameTranslations = {this.props.addTopicNameTranslations}
            deleteTopicTransltion = {this.props.deleteTopicTransltion}
          />
        )
      }}
    />
  )

  render () {
    const { routes, ...rest } = this.props
    return (
      <div className="research-repo">
        <Sidebar
          links={this.state.linksArray}
        />
        <div className="main-research-content">
          <Switch>
            {routes.map((route, index) =>
              this.subRouteMapper(route, index, {
                openModal: this.openModal,
                updateState: this.updateState,
                ...rest,
              })
            )}
          </Switch>
        </div>
        {this.state.modalOpen &&
          <ShareModal closeModal={this.closeModal} modalState={this.state.modalState} />}
        {this.props.thankYouModalOpen &&
          <CustomCrowdThankYouModal
            isOpen={this.props.thankYouModalOpen}
            onCancel={this.props.toggleThankYouModal}
          />
        }
      </div>
    )
  }
}

const mapDispatch = {
  fetchAllInformationForProject,
  editConferenceLinkDetails,
  toggleEditConferenceLinkModal,
  clearTranslations,
  showSnackbarMessageError: message => ({
    type: 'SHOW_MESSAGE',
    payload: {
      message: message,
      className: 'copy-screeners-snackbar',
    }
  }),
  getEmailTemplate,
  hideSnackbarMessage: () => ({ type: 'HIDE_MESSAGE' }),
  toggleTranslationsModal,
  setMeetingInfromation,
  addConferenceLinkMeetingInfoTranslations,
  addTranslations,
  deleteTranslation,
  toggleInconsistentMeetingInformationModal,
  toggleTranslationsErrorModal,
  toggleTopicTransltionsErrorModal,
  deleteTranslationDirectly,
  closePreviewLinkModal: () => ({ type: 'CLOSE_PREVIEW_CONFERENCE_LINK_MODAL' }),
  addTopicNameTranslations,
  deleteTopicTransltion
}

const mapState = state => ({
  currentProject: state.currentProject,
  surveyErrors: state.surveyErrors.surveyErrors,
  displayAllErrors: state.surveyErrors.displayAllErrors,
  questionErrors: state.surveyErrors.questionErrors,
  survey: state.survey,
  login: state.login,
  t:localizedTranslate('en', state.translations.en_us),
  previewConferenceLinkModal: state.ui.previewConferenceLinkModal,
  exampleEmail: state.editSession.exampleEmail

})

export default connect(mapState, mapDispatch)(Project)
